import { render, staticRenderFns } from "./CompetenciesComponent.vue?vue&type=template&id=1b345ecc&scoped=true"
import script from "./CompetenciesComponent.vue?vue&type=script&lang=js"
export * from "./CompetenciesComponent.vue?vue&type=script&lang=js"
import style0 from "./CompetenciesComponent.vue?vue&type=style&index=0&id=1b345ecc&prod&scoped=true&lang=scss"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "1b345ecc",
  null
  
)

export default component.exports